exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.ScopeSelector .scope{display:inline-block;cursor:pointer;min-width:1.3em;min-height:1.3em;text-align:center\n}\n.ScopeSelector .scope.selected svg{color:#b9b9ba;color:var(--lightText, #b9b9ba)\n}", ""]);

// exports
